import { createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  documentWrapper: {
    maxWidth: '100%',
    width: '100%',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
